const overrideLink = (theme) => {
  theme.overrides["MuiLink"] = {
    root: {
    }
  };
}

export default overrideLink;